import { FC } from "react";
import { IconProps } from "@/shared/types/icon";
import { Svg } from "@abel-technologies-as/components";

export const Delete: FC<IconProps> = ({ width = "22.2", height = "20.8", color = "none", onClick, className }) => {
	return (
		<Svg onClick={onClick} className={className} width={width} height={height} viewBox="0 0 16 16" fill={color}>
			<path
				d="M9.99958 9.99992L8.00001 8.00013M8.00001 8.00013L6.00001 5.99992M8.00001 8.00013L6.00044 9.99992M8.00001 8.00013L10 5.99992M14.6667 7.99992C14.6667 4.31802 11.6819 1.33325 8.00001 1.33325C4.31811 1.33325 1.33334 4.31802 1.33334 7.99992C1.33334 11.6818 4.31811 14.6666 8.00001 14.6666C11.6819 14.6666 14.6667 11.6818 14.6667 7.99992Z"
				stroke="#667085"
				strokeWidth="1.5"
				stroke-linecap="round"
			/>
		</Svg>
	);
};
